export default __webpack_public_path__ + "static/media/icon-person.65bfd204.svg";